var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"expo-btn expo-btn-white",attrs:{"type":"button"},on:{"click":function($event){return _vm.download(_vm.pageId)}}},[_vm._v(" "+_vm._s(_vm.$t("general.download_pdf"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }